import { TransitionsOptions } from '@mui/material';

export const transitions: TransitionsOptions = {
  duration: {
    shortest: 100,
    shorter: 150,
    short: 200,
    standard: 280,
    complex: 350,
    enteringScreen: 225,
    leavingScreen: 195,
  },
  easing: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
  },
};
